import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchResultsAction } from 'store/actions/search';
import * as allCol from 'utils/table/tableColumns';
import { views } from 'enums/menu-enums';
import Search from 'components/common/SearchBar';
import TableCont from 'components/common/TableContainer';
import Table from 'components/common/PortalTable';
import SearchLoadTable from 'components/common/SearchLoadingTable';
import AllUnSelectedTabs from 'components/common/UnSelectedTabs';

const SearchAndTable = ({ table }) => {
  const searchPending = useSelector((state) => state.search.pending);
  const activeSearch = useSelector((state) => state.search.searchParam);
  const currentView = useSelector((state) => state.currentView);
  const currentOpenTab = useSelector((state) => state.openOrders.currentTab);
  const currentCompletedTab = useSelector((state) => state.completedOrders.currentTab);
  const confirmOrders = useSelector((state) => get('openOrders.confirm')(state));
  const toShipOrders = useSelector((state) => get('openOrders.toShip')(state));
  const shippedOrders = useSelector((state) => get('openOrders.shipped')(state));
  const allOpenOrders = useSelector((state) => get('openOrders.all')(state));
  const deliveredOrders = useSelector((state) => get('completedOrders.delivered')(state));
  const returnedOrders = useSelector((state) => get('completedOrders.returned')(state));
  const canceledOrders = useSelector((state) => get('completedOrders.canceled')(state));
  const allCompletedOrders = useSelector((state) => get('completedOrders.all')(state));

  const dispatch = useDispatch();

  const handleSearchSubmit = (searchParam) => {
    dispatch(
      getSearchResultsAction(
        searchParam,
        currentView === 'Open' ? currentOpenTab : currentCompletedTab,
        currentView,
      ),
    );
  };

  let columns;

  if (table === views.activeListings) {
    columns = allCol.activeColumns;
  }

  if (table === views.open) {
    switch (currentOpenTab) {
      case 'shipped':
        columns = allCol.shippedColumns;
        break;
      case 'toShip':
        columns = allCol.toShipColumns;
        break;
      case 'confirm':
        columns = allCol.confirmColumns;
        break;
      default:
        columns = allCol.openColumns;
        break;
    }
  }

  if (table === views.completed) {
    columns = allCol.completedColumns;
  }

  return (
    <React.Fragment>
      <Search
        onSubmit={handleSearchSubmit}
        currentView={currentView}
        placeholder="Search by SKU, Product Name…"
      />
      <AllUnSelectedTabs
        confirmOrders={confirmOrders}
        toShipOrders={toShipOrders}
        shippedOrders={shippedOrders}
        allOpenOrders={allOpenOrders}
        deliveredOrders={deliveredOrders}
        returnedOrders={returnedOrders}
        canceledOrders={canceledOrders}
        allCompletedOrders={allCompletedOrders}
        currentView={currentView}
        activeSearch={activeSearch}
        table={table}
        currentOpenTab={currentOpenTab}
        currentCompletedTab={currentCompletedTab}
      />
      <TableCont tabs={table !== views.activeListings}>
        {searchPending ? (
          <SearchLoadTable columns={allCol.activeColumnsLoading} />
        ) : (
          <Table
            columns={columns}
            table={table}
            tab={table === views.open ? currentOpenTab : currentCompletedTab}
          />
        )}
      </TableCont>
    </React.Fragment>
  );
};

SearchAndTable.propTypes = {
  table: PropTypes.string.isRequired,
};

export default SearchAndTable;
